__turbopack_context__.v({
  "content": "404-module-scss-module__Gt2CPG__content",
  "farewell": "404-module-scss-module__Gt2CPG__farewell",
  "link": "404-module-scss-module__Gt2CPG__link",
  "logo": "404-module-scss-module__Gt2CPG__logo",
  "main": "404-module-scss-module__Gt2CPG__main",
  "message": "404-module-scss-module__Gt2CPG__message",
});
